






























import { Component, Prop, Vue } from 'vue-property-decorator';
import PageLoader from '@components/common/PageLoader.vue';
import ApiHelpers from '@/api/ApiHelper';
import Toast from '@common/helpers/toast';
import ApiHelper from 'api-helper';


@Component({
  components: {
    PageLoader,
  },
})

export default class PopupConfirmDelete extends Vue {
  public isLoading: boolean = false;
  public perPage = 10;
  public page = this.$route.query.page || 1;

  @Prop({
    default() {
      return [];
    },
  })
  public selectedMenu!: any;

  public searchForm = {
    name: this.$route.query.name || '',
    clinic_name: this.$route.query.clinic_name,
    order: '-created_at',
    per_page: this.perPage,
    page: this.page,
    with: 'clinics',
    menu_status: this.$route.query.menu_status === '0' ? 0 : parseInt(this.$route.query.menu_status as string) || null,
    is_default: this.$route.query.is_default === '0' ? 0 : parseInt(this.$route.query.is_default as string) || null,
  };

  async confirm() {
    // handle when click confirm
    try {
      this.isLoading = true;
      await ApiHelpers.getApi('MedicalMenuApi').delete(this.selectedMenu.id);
      const res = await ApiHelper.getApi('MedicalMenuV2Api').getList(this.searchForm);
      this.$emit('submit', res.data);
    } catch (error) {
      this.toast(error);
    } finally {
      this.$modal.hide('popup-confirm-delete');
      this.isLoading = false;
    }
  }

  cancel() {
    // Hide popup when click cancel
    this.$modal.hide('popup-confirm-delete');
  }

  private toast(error: any) {
    const {
      errors: { id: idError },
    } = error.response.data;
    if (idError) {
      return Toast.error('英数字で入力してください。');
    }
    Toast.error(error.response.data.message);
  }
}
